module.exports = {"select":"Select File","loadError":"File could not be loaded","typeError":"Unsupported file type","sizeError":"Maximum file size is {size}"}